/**
 * Product brand logos, keyed by backend project id and served from
 * public/logos. A project without an entry falls back to a generic icon, so
 * registering a new project never renders a broken image.
 *
 * These are the stock lockups exactly as each product publishes them —
 * transparent, unmodified. Their wordmarks are near-black (#040000 and
 * #1c1c1c), so every surface that shows one must be light; that is why the
 * AppBar is a pale bar rather than the primary colour.
 */
export const PROJECT_LOGOS: Record<string, string> = {
  rmng: '/logos/esp-rainmaker-neo.svg',
  esp_private_agents: '/logos/esp-private-agents.svg',
};

export function projectLogo(projectId: string | undefined): string | undefined {
  return projectId ? PROJECT_LOGOS[projectId] : undefined;
}
